/**
 * Normalizers for a prescriber's licence numbers. Each returns the single
 * stored form, or `null` when the input can't be one. They are pure so the
 * web form and the API share the same rules.
 *
 * These numbers are workforce personal data (RA 10173), not PHI. Treat them
 * the same way in practice: never log inputs or outputs, and never put them
 * in an error message.
 */ /**
 * PRC licence number as stored: 6 to 12 upper-case letters and digits
 * (EMR-FR-6.2). Mirrored by the `prescriber_profiles_prc_license_no_check`
 * DB CHECK. Format only; there is no PRC service to verify against.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PRC_LICENSE_NO_PATTERN () {
        return PRC_LICENSE_NO_PATTERN;
    },
    get PRESCRIBER_REFERENCE_NO_PATTERN () {
        return PRESCRIBER_REFERENCE_NO_PATTERN;
    },
    get normalizePrcLicenseNo () {
        return normalizePrcLicenseNo;
    },
    get normalizePrescriberReferenceNo () {
        return normalizePrescriberReferenceNo;
    }
});
const PRC_LICENSE_NO_PATTERN = /^[0-9A-Z]{6,12}$/;
const PRESCRIBER_REFERENCE_NO_PATTERN = /^[0-9A-Z -]{3,20}$/;
function normalizePrcLicenseNo(input) {
    const candidate = input.trim().toUpperCase();
    if (!PRC_LICENSE_NO_PATTERN.test(candidate)) {
        return null;
    }
    return candidate;
}
function normalizePrescriberReferenceNo(input) {
    const candidate = input.trim().toUpperCase();
    if (!PRESCRIBER_REFERENCE_NO_PATTERN.test(candidate)) {
        return null;
    }
    return candidate;
}
